import api from '@/services/api';

const visitor = {
  namespaced: true,
  state: () => ({
    visitorApplyInfo: {},
    visitorList: [],
    visitorCarList: [],
    visitorInMonth: [],
    visitorInMonthItem: [],
    visitorDefaultTypeList: [],
    visitorTypeList: [],
    visitorAreaList: [],
    visitorBuildingList: [],
  }),
  mutations: {
    updateVisitorApplyInfo(state, payload) {
      state.visitorApplyInfo = payload;
    },
    updateVisitorList(state, payload) {
      state.visitorList = payload;
    },
    updateVisitorCarList(state, payload) {
      state.visitorCarList = payload;
    },
    updateVisitorInMonth(state, payload) {
      state.visitorInMonth = payload;
    },
    updateVisitorInMonthItem(state, payload) {
      state.visitorInMonthItem = payload;
    },
    visitorTypeDefaultListState(state, payload) {
      state.visitorDefaultTypeList = payload;
    },
    visitorTypeListState(state, payload) {
      state.visitorTypeList = payload;
    },
    visitorAreaListState(state, payload) {
      state.visitorAreaList = payload;
    },
    visitorBuildingListState(state, payload) {
      state.visitorBuildingList = payload;
    },
  },
  actions: {
    async getVisitorType({ commit }, params) {
      try {
        const [status, res] = await api.getVisitorType(params);
        if (status) {
          const list = res.data.map(i => ({ ...i, isPark: i.accessType === 'booking_park' }));
          const result = res.data.map(i => i.type);
          commit('visitorTypeDefaultListState', list);
          commit('visitorTypeListState', result);
        }
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async getVisitorArea({ commit }, authorId) {
      try {
        const [status, res] = await api.getVisitorArea({ params: { authorId: authorId } });
        if (status) {
          const list = res.data.map(i => ({ id: i.id, text: i.area || i.name }));
          commit('visitorAreaListState', list);
        }
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async getVisitorBuilding({ commit }, authorId) {
      try {
        const [status, res] = await api.getVisitorBuilding({ params: { authorId: authorId } });
        if (status && res) {
          commit('visitorBuildingListState', res.data || []);
        }
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};

export default visitor;
